import React from 'react';

export default function TrainingMedia({ src, alt, placeholderLabel, eager = false }) {
  if (src) {
    if (!alt) throw new TypeError('Approved training media requires factual alt text');

    return (
      <figure className="training-media training-media--approved">
        <img
          src={src}
          alt={alt}
          width="1200"
          height="800"
          loading={eager ? 'eager' : 'lazy'}
        />
      </figure>
    );
  }

  if (!placeholderLabel) throw new TypeError('Training media placeholders require a visible label');

  return (
    <figure className="training-media training-media--placeholder">
      <div className="training-media__frame" aria-hidden="true" />
      <figcaption>{placeholderLabel}</figcaption>
    </figure>
  );
}
